import { render, staticRenderFns } from "./IntegrationLogizard.vue?vue&type=template&id=4e277683&scoped=true&"
import script from "./IntegrationLogizard.vue?vue&type=script&lang=ts&"
export * from "./IntegrationLogizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e277683",
  null
  
)

export default component.exports